"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.average = exports.allTrue = void 0;
const allTrue = (arr) => arr.findIndex((i) => !Boolean(i)) === -1;
exports.allTrue = allTrue;
const average = (nums) => nums.length > 0
    ? nums.reduce((total, num) => total + num) / nums.length
    : NaN;
exports.average = average;
